import { ReactElement } from 'react';

export interface IMicrositeRecipientLog {
    id: number;
    micrositeRecipientId: number;
    micrositeRecipientStatus: string;
    logDateTime: string;
    logEntry: string;
    userId: number;
    userName: string;
    isEvent: boolean;
    eventType?: number;
    centerChange?: boolean;
    prevCenterName?: string;
    newCenterName?: string;
    customSiteStatus?: number;
}